import Image from 'next/image';
import cn from 'classnames';
import { UiTooltip, UiText } from 'znanie-uikit';

import { decl } from 'utils/helpers';

import { SpeakerType } from 'graphql/types';

import css from './ContentSpeakersAvatars.module.scss';

type TUsageMode = 'preview' | 'full';

interface IProps {
  speakers: SpeakerType[];
  invertedColor?: boolean;
  usageMode?: TUsageMode;
}

const ContentSpeakersAvatars = ({
  speakers,
  invertedColor,
  usageMode = 'preview',
}: IProps) => {
  const getSpeakerPhoto = (item: SpeakerType) => (
    <div
      className={cn(css.speakerImg, usageMode === 'full' && css.speakerImgFull)}
    >
      <Image
        src={item.photoUrl || '/img/avatar-empty.svg'}
        alt={`спикер ${item.firstName} ${item.lastName}`}
        layout="fill"
        quality="100"
        objectFit="cover"
      />
      )
    </div>
  );

  const getSpeakersNamesList = (speakers: SpeakerType[]) => (
    <ul className={css.speakersNamesList}>
      {speakers.map((s, index) => (
        <li key={index}>
          {s.firstName} {s.lastName}
        </li>
      ))}
    </ul>
  );

  const otherSpeakers = speakers.slice(3, speakers.length);

  return (
    <div className={css.speakers}>
      {speakers.length > 1 ? (
        <div className={css.multiSpeaker}>
          <UiTooltip
            content={getSpeakersNamesList(speakers)}
            placement="bottom-start"
            arrow={false}
          >
            <ul className={css.speakersImgList}>
              {speakers.slice(0, 3).map((speaker: SpeakerType) => (
                <li key={`speaker_photo_${speaker.id}`}>
                  {getSpeakerPhoto(speaker)}
                </li>
              ))}
            </ul>
          </UiTooltip>
          {otherSpeakers.length > 0 && (
            <UiText
              className={cn(
                css.otherSpeakersLabel,
                invertedColor && css.invertedColor
              )}
              size="small"
              weight="normal"
            >
              +{otherSpeakers.length}{' '}
              {decl(otherSpeakers.length, ['спикер', 'спикера', 'спикеров'])}
            </UiText>
          )}
        </div>
      ) : (
        <>
          {speakers[0] && (
            <div className={css.singleSpeaker}>
              {getSpeakerPhoto(speakers[0])}
              <div
                className={cn(
                  css.speakerName,
                  usageMode === 'full' && css.speakerNameFull,
                  invertedColor && css.invertedColor
                )}
              >
                <span>
                  {speakers[0].firstName} {speakers[0].lastName}
                </span>
                {usageMode === 'full' && (
                  <UiText
                    className={css.speakerDescription}
                    as="p"
                    size="small_x"
                    weight="normal"
                    color="grey"
                  >
                    {speakers[0].title}
                  </UiText>
                )}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ContentSpeakersAvatars;
